module.exports = __webpack_public_path__ + "img/3.c755d556.png";